module.exports = __webpack_public_path__ + "static/media/fly0122.0db5bab8.webp";